import OkReportDeveloperForm from './OkReportDeveloperForm'
import enhance from './OkReportDeveloperForm.enhancer'

export default enhance(OkReportDeveloperForm)



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/OkReportDeveloperForm/index.js